"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHashParams = exports.OTP_WAIT_TIME = exports.SEND_OTP_COMPONET_DATA = exports.domainRegex = exports.dataRegex = exports.javascriptRegex = exports.emailRegexp = exports.phoneRegex = exports.ComponentToBeRendered = exports.ErrorMap = void 0;
exports.ErrorMap = {
    EMPTY_ERROR: 'This field is required',
    INVALID_PHONE: 'Enter a valid phone number',
    INVALID_EMAIL: 'Enter a valid email',
};
exports.ComponentToBeRendered = {
    SEND_OTP: 'SEND_OTP',
    READ_OTP: 'READ_OTP',
};
exports.phoneRegex = new RegExp('^[6-9][0-9]{9}$', 'i');
exports.emailRegexp = new RegExp(/^[a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1}([a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1})*[a-zA-Z0-9]@[a-zA-Z0-9][-\.]{0,1}([a-zA-Z][-\.]{0,1})*[a-zA-Z0-9]\.[a-zA-Z0-9]{1,}([\.\-]{0,1}[a-zA-Z]){0,}[a-zA-Z0-9]{0,}$/i);
exports.javascriptRegex = new RegExp('^.*[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:.*');
exports.dataRegex = new RegExp('^.*[\u0000-\u001F ]*d[\r\n\t]*a[\r\n\t]*t[\r\n\t]*a[\r\n\t]*:.*');
exports.domainRegex = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/;
exports.SEND_OTP_COMPONET_DATA = {
    title: 'Enter verification code',
    subTitle: 'OTP has been sent to',
    edit: 'Edit',
};
exports.OTP_WAIT_TIME = 30;
const checkPhoneREGNoRegex = (regexValue) => {
    var _a;
    if ((regexValue === null || regexValue === void 0 ? void 0 : regexValue.match(/^[a-zA-Z0-9+%\s]{0,15}$/)) !== null) {
        return ((_a = regexValue === null || regexValue === void 0 ? void 0 : regexValue.match(/^[a-zA-Z0-9+%\s]{0,15}$/)) === null || _a === void 0 ? void 0 : _a.length) < 15;
    }
    else {
        return false;
    }
};
const getHashParams = () => {
    let hashstr = window && window.location.hash.split('#')[1];
    let regNo = hashstr && checkPhoneREGNoRegex(hashstr.split('&')[0])
        ? hashstr.split('&')[0]
        : '';
    let phoneNo = hashstr && checkPhoneREGNoRegex(hashstr.split('&')[1])
        ? hashstr.split('&')[1]
        : '';
    const hashParams = {
        regNo,
        phoneNo,
    };
    return hashParams;
};
exports.getHashParams = getHashParams;
//# sourceMappingURL=utils.js.map